export default function home_videos() {
	
	$('.block-videos .video-list').owlCarousel({
    items: 2,
    dotsEach: false,
    loop: true,
    nav: true,
    smartSpeed: 1000,
    mouseDrag: true,
    margin: 30,
    navText: ['<i class="fas fa-arrow-left"></i>','<i class="fas fa-arrow-right"></i>']
  });
	
}